export const scenarioKeys = {
	all: ["scenarios"] as const,
	current: (friendId: number) =>
		[...scenarioKeys.all, "current", friendId] as const,
} as const
